require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-plum-cake.json") })
        }
      }, "path---recipes-plum-cake");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-plum-cake!./.cache/json/recipes-plum-cake.json
// module id = 737
// module chunks = 231608221292675